export default __webpack_public_path__ + "static/media/Intermediate.2e4f581b.png";